import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import OrderView from "@/views/OrderView.vue";
import StoreView from "@/views/StoresView.vue";
import DetailView from "@/views/DetailView.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/order',
        name: 'order',
        component: OrderView
    },
    {
        path: '/stores',
        name: 'store',
        component: StoreView
    },
    {
        path: '/detail',
        name: 'detail',
        component: DetailView
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    // document.title = ""
  next()
})

export default router
